import { compareManagementConstrainedOptimization } from './managementConstrainedComparison'

const STORAGE_KEY = 'management-constrained-portfolio-decision-evidence:v1'

const sameScenarioUniverse = (response) => {
    const scenarioIds = response?.run_context?.scenario_ids
    const allocation = response?.allocation
    if (!Array.isArray(scenarioIds) || scenarioIds.length === 0 || !Array.isArray(allocation)) return false
    const allocatedIds = allocation.map((row) => String(row?.scenario_id))
    return allocation.length === scenarioIds.length && scenarioIds.every((id) => allocatedIds.includes(String(id)))
}

const isPersistedComparableEvidence = (evidence) => {
    const response = evidence?.constrainedResponse
    const requestedCapital = Number(evidence?.requestedCapital)
    return evidence?.schemaVersion === 1 &&
        evidence?.authority === 'PORTFOLIO_CAPITAL_OPTIMIZATION' &&
        evidence?.evaluationStatus === 'READY' &&
        evidence?.comparisonStatus === 'COMPARABLE' &&
        evidence?.persistenceStatus === 'ready' &&
        Number.isFinite(requestedCapital) && requestedCapital > 0 &&
        Number(response?.available_capital) === requestedCapital &&
        Number.isFinite(Number(response?.modeled_optimal_deployment)) &&
        sameScenarioUniverse(response) &&
        response.allocation.every((row) =>
            row?.scenario_id !== undefined && Number.isFinite(Number(row?.allocated_investment))
        )
}

export function isManagementConstrainedDecisionReady({
    evaluation,
    acceptedEvidence,
    currentRequestedCapital,
    persistenceStatus
}) {
    if (evaluation?.status !== 'READY' || persistenceStatus !== 'ready') return false
    if (!Number.isFinite(Number(currentRequestedCapital)) || Number(currentRequestedCapital) <= 0) return false
    if (Number(evaluation.requestedCapital) !== Number(currentRequestedCapital)) return false
    if (Number(evaluation.result?.available_capital) !== Number(currentRequestedCapital)) return false
    if (!sameScenarioUniverse(evaluation.result)) return false
    return compareManagementConstrainedOptimization(acceptedEvidence, evaluation.result).status === 'COMPARABLE'
}

export function persistManagementConstrainedDecisionEvidence({
    acceptedEvidence,
    constrainedResponse,
    requestedCapital
}) {
    const evidence = {
        schemaVersion: 1,
        authority: 'PORTFOLIO_CAPITAL_OPTIMIZATION',
        evaluationStatus: 'READY',
        comparisonStatus: 'COMPARABLE',
        persistenceStatus: 'ready',
        requestedCapital: Number(requestedCapital),
        acceptedResponse: acceptedEvidence.optimizerResponse,
        constrainedResponse
    }
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(evidence))
    return evidence
}

export function getManagementConstrainedDecisionEvidence() {
    try {
        const evidence = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY))
        return isPersistedComparableEvidence(evidence) ? evidence : null
    } catch (_) {
        return null
    }
}

export function clearManagementConstrainedDecisionEvidence() {
    window.sessionStorage.removeItem(STORAGE_KEY)
}

export { STORAGE_KEY }
